import { Field } from "../formHelpers";

export default function MedicalSection({ mKey, pe, errors, setIns }) {
  const hasCondition = !!pe?.hasCondition;
  const onMedication = !!pe?.onMedication;

  return (
    <div className="mt-6 pt-6 border-t border-subtle">
      <p className="text-sm font-semibold text-secondary-brand mb-3 uppercase tracking-wider">
        Medical
      </p>
      <div className="flex items-center justify-between gap-3 mb-3">
        <label className="text-sm">Any pre-existing disease?</label>
        <label className="inline-flex items-center gap-2 cursor-pointer">
          <input
            type="checkbox"
            checked={hasCondition}
            onChange={(e) => setIns(mKey, "preExisting.hasCondition", e.target.checked)}
            className="h-4 w-4 accent-[color:var(--accent)]"
            data-testid={`pe-toggle-${mKey}`}
          />
          <span className="text-sm text-secondary-brand">Yes</span>
        </label>
      </div>

      {hasCondition && (
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
          <Field label="Condition" testId={`condition-${mKey}`} error={errors[`${mKey}-condition`]}>
            <input
              type="text"
              value={pe.condition || ""}
              onChange={(e) => setIns(mKey, "preExisting.condition", e.target.value)}
              className={`form-input ${errors[`${mKey}-condition`] ? "error" : ""}`}
              placeholder="e.g. Diabetes"
              data-testid={`input-condition-${mKey}`}
            />
          </Field>
          <Field label="Since when" testId={`since-${mKey}`} error={errors[`${mKey}-since`]}>
            <input
              type="text"
              value={pe.since || ""}
              onChange={(e) => setIns(mKey, "preExisting.since", e.target.value)}
              className={`form-input ${errors[`${mKey}-since`] ? "error" : ""}`}
              placeholder="e.g. 2019 or Jan 2019"
              data-testid={`input-since-${mKey}`}
            />
          </Field>
          <div className="sm:col-span-2 flex items-center gap-2">
            <input
              type="checkbox"
              id={`meds-${mKey}`}
              checked={onMedication}
              onChange={(e) => setIns(mKey, "preExisting.onMedication", e.target.checked)}
              className="h-4 w-4 accent-[color:var(--accent)]"
              data-testid={`meds-toggle-${mKey}`}
            />
            <label htmlFor={`meds-${mKey}`} className="text-sm">
              Currently taking medicine?
            </label>
          </div>
          {onMedication && (
            <>
              <Field label="Medicine name" testId={`medicine-${mKey}`} error={errors[`${mKey}-medicine`]}>
                <input
                  type="text"
                  value={pe.medicineName || ""}
                  onChange={(e) => setIns(mKey, "preExisting.medicineName", e.target.value)}
                  className={`form-input ${errors[`${mKey}-medicine`] ? "error" : ""}`}
                  placeholder="e.g. Metformin"
                  data-testid={`input-medicine-${mKey}`}
                />
              </Field>
              <Field label="Doses per day" testId={`doses-${mKey}`} error={errors[`${mKey}-doses`]}>
                <input
                  type="number"
                  min="1"
                  max="20"
                  value={pe.dosesPerDay ?? ""}
                  onChange={(e) => {
                    const v = e.target.value.replace(/\D/g, "");
                    setIns(mKey, "preExisting.dosesPerDay", v === "" ? "" : Number(v));
                  }}
                  className={`form-input ${errors[`${mKey}-doses`] ? "error" : ""}`}
                  placeholder="e.g. 2"
                  data-testid={`input-doses-${mKey}`}
                />
              </Field>
            </>
          )}
        </div>
      )}
    </div>
  );
}
